const account_center = {
    home: {
        title: '找不到頁面',
        description: '此頁面無法使用。',
    },
    page: {
        title: '帳戶',
        security_title: '安全',
        security_description: '你可以在這裡變更帳戶設定，以確保帳戶安全。',
        profile_title: '個人資料',
        profile_description: '在這裡變更你的個人資訊。',
        sidebar_personal_info: '個人資料',
        sidebar_security: '安全',
        sidebar_sessions: '工作階段',
        support: '支援',
    },
    verification: {
        title: '安全驗證',
        description: '為保護帳戶安全，請確認是您本人。請選擇用於驗證身分的方法。',
        error_send_failed: '驗證碼傳送失敗，請稍後再試。',
        error_invalid_code: '驗證碼無效或已過期。',
        error_verify_failed: '驗證失敗，請重新輸入驗證碼。',
        verification_required: '驗證已失效，請再次驗證您的身分。',
        try_another_method: '嘗試其他驗證方式',
        no_available_methods_title: '沒有可用的驗證方式',
        no_available_methods_description: '您尚未設定任何驗證方式。請先在您的帳戶中新增密碼、電子郵件或電話號碼。',
    },
    password_verification: {
        title: '驗證密碼',
        description: '為保護帳戶安全，請輸入您的密碼完成驗證。',
        error_failed: '密碼錯誤，請重新輸入。',
    },
    verification_method: {
        password: {
            name: '密碼',
            description: '驗證您的密碼',
        },
        email: {
            name: '電子郵件驗證碼',
            description: '傳送驗證碼到您的電子郵件',
        },
        phone: {
            name: '電話驗證碼',
            description: '傳送驗證碼到您的電話號碼',
        },
    },
    email: {
        title: '連結電子郵件',
        description: '連結你的電子郵件以登入或協助帳戶復原。',
        verification_title: '輸入電子郵件驗證碼',
        verification_description: '驗證碼已傳送至你的電子郵件 {{email_address}}。',
        success: '已成功連結主要電子郵件。',
        verification_required: '驗證已失效，請再次驗證您的身分。',
    },
    phone: {
        title: '連結電話號碼',
        description: '連結你的電話號碼以登入或協助帳戶復原。',
        verification_title: '輸入簡訊驗證碼',
        verification_description: '驗證碼已傳送至你的電話 {{phone_number}}。',
        success: '已成功連結主要電話。',
        verification_required: '驗證已失效，請再次驗證您的身分。',
    },
    username: {
        title: '設定使用者名稱',
        description: '使用者名稱只能包含字母、數字和底線。',
        policy_description: '{{requirements}}',
        success: '使用者名稱已成功更新。',
    },
    security: {
        add: '新增',
        change: '變更',
        remove: '移除',
        not_set: '未設定',
        social_sign_in: '社群登入',
        social_not_linked: '未連結',
        email_phone: '電子郵件 / 電話號碼',
        email: '電子郵件',
        phone: '電話號碼',
        password: '密碼',
        configured: '已設定',
        not_configured: '未設定',
        two_step_verification: '兩步驟驗證',
        authenticator_app: '身份驗證器應用程式',
        passkeys: '通行密鑰',
        backup_codes: '備用碼',
        email_verification_code: '電郵驗證碼',
        phone_verification_code: '電話驗證碼',
        passkeys_count_one: '{{count}} 個通行密鑰',
        passkeys_count_other: '{{count}} 個通行密鑰',
        backup_codes_count_one: '{{count}} 個備用碼',
        backup_codes_count_other: '{{count}} 個備用碼',
        view: '檢視',
        manage: '管理',
        turn_on_2_step_verification_description: '增加額外的安全保護。登入時將要求進行第二步驟驗證。',
        turn_off_2_step_verification: '關閉兩步驟驗證',
        turn_off_2_step_verification_description: '關閉兩步驟驗證將移除登入時帳戶的額外保護層。確定要繼續嗎？',
        disable_2_step_verification: '關閉',
        no_verification_method_warning: '你尚未新增第二種驗證方式。請至少新增一種以在登入時啟用兩步驟驗證。',
        passkey_sign_in_prompt: '提示設定通行密鑰',
        passkey_sign_in_prompt_description: '開啟後，系統會提示你設定通行密鑰，以實現更快速、更安全的登入。',
        account_removal: '帳戶刪除',
        delete_your_account: '刪除你的帳戶',
        delete_account: '刪除帳戶',
        remove_username_confirmation_title: '移除使用者名稱',
        remove_username_confirmation_description: '移除後，你將無法再使用此使用者名稱登入。確定要繼續嗎？',
        remove_email_confirmation_title: '移除電子郵件地址',
        remove_email_confirmation_description: '移除後，你將無法再使用此電子郵件地址登入。確定要繼續嗎？',
        remove_phone_confirmation_title: '移除手機號碼',
        remove_phone_confirmation_description: '移除後，你將無法再使用此手機號碼登入。確定要繼續嗎？',
        email_removed: '電子郵件地址已成功移除。',
        phone_removed: '手機號碼已成功移除。',
        username_removed: '使用者名稱已成功移除。',
    },
    social: {
        linked: '已成功連結 {{connector}}。',
        not_enabled: '此社群登入方式尚未啟用。請聯絡管理員尋求協助。',
        removed: '已成功移除 {{connector}}。',
        remove_confirmation_title: '移除社群帳號',
        remove_confirmation_description: '如果你移除 {{connector}}，在重新加入之前，你可能無法再透過它登入。',
    },
    password: {
        title: '設定密碼',
        description: '建立新密碼以保障您的帳戶安全。',
        success: '密碼已成功更新。',
    },
    code_verification: {
        send: '傳送驗證碼',
        resend: '尚未收到？<a>重新傳送驗證碼</a>',
        resend_countdown: '尚未收到？{{seconds}} 秒後可重新傳送。',
    },
    email_verification: {
        title: '驗證您的電子郵件',
        prepare_description: '為保護帳戶安全，請確認是您本人。傳送驗證碼到您的電子郵件。',
        email_label: '電子郵件地址',
        send: '傳送驗證碼',
        description: '驗證碼已傳送至您的電子郵件 {{email}}。請輸入驗證碼以繼續。',
        resend: '尚未收到？<a>重新傳送驗證碼</a>',
        not_received: '尚未收到？',
        resend_action: '重新傳送驗證碼',
        resend_countdown: '尚未收到？{{seconds}} 秒後可重新傳送。',
        error_send_failed: '驗證碼傳送失敗，請稍後再試。',
        error_verify_failed: '驗證失敗，請重新輸入驗證碼。',
        error_invalid_code: '驗證碼無效或已過期。',
    },
    phone_verification: {
        title: '驗證您的電話',
        prepare_description: '為保護帳戶安全，請確認是您本人。傳送驗證碼到您的電話。',
        phone_label: '電話號碼',
        send: '傳送驗證碼',
        description: '驗證碼已傳送至您的電話 {{phone}}。請輸入驗證碼以繼續。',
        resend: '尚未收到？<a>重新傳送驗證碼</a>',
        resend_countdown: '尚未收到？{{seconds}} 秒後可重新傳送。',
        error_send_failed: '驗證碼傳送失敗，請稍後再試。',
        error_verify_failed: '驗證失敗，請重新輸入驗證碼。',
        error_invalid_code: '驗證碼無效或已過期。',
    },
    mfa: {
        totp_already_added: '您已新增過身份驗證器應用程式，請先移除現有的。',
        totp_not_enabled: '身份驗證器應用程式 OTP 未啟用。請聯繫管理員尋求協助。',
        backup_code_already_added: '您已擁有有效的備份碼，請先使用或移除它們再產生新的。',
        backup_code_not_enabled: '備份碼未啟用。請聯繫管理員尋求協助。',
        backup_code_requires_other_mfa: '備份碼需要先設定其他 MFA 方式。',
        passkey_not_enabled: '通行密鑰未啟用。請聯繫管理員尋求協助。',
        passkey_already_registered: '此通行密鑰已綁定到您的帳戶，請使用其他認證器。',
    },
    update_success: {
        default: {
            title: '更新成功',
            description: '您的變更已成功儲存。',
        },
        email: {
            title: '電子郵件地址已更新！',
            description: '您的帳戶電子郵件地址已成功變更。',
        },
        phone: {
            title: '電話號碼已更新！',
            description: '您的帳戶電話號碼已成功變更。',
        },
        username: {
            title: '使用者名稱已更新！',
            description: '您的帳戶使用者名稱已成功變更。',
        },
        password: {
            title: '密碼已更新！',
            description: '您的帳戶密碼已成功變更。',
        },
        totp: {
            title: '身份驗證器應用程式已新增！',
            description: '身份驗證器應用程式已成功連結至您的帳戶。',
        },
        totp_replaced: {
            title: '身份驗證器應用程式已替換！',
            description: '你的身份驗證器應用程式已成功替換。',
        },
        backup_code: {
            title: '備用碼已產生！',
            description: '您的備用碼已儲存。請將它們保存在安全的地方。',
        },
        passkey: {
            title: '通行密鑰已新增！',
            description: '通行密鑰已成功連結至您的帳戶。',
        },
        social: {
            title: '社群帳號已連結！',
            description: '您的社群帳號已成功連結。',
        },
    },
    backup_code: {
        title: '備用碼',
        description: '如果您在兩步驗證時遇到問題，可以使用這些備用碼中的一個來存取您的帳戶。每個代碼只能使用一次。',
        copy_hint: '請務必複製並保存在安全的地方。',
        generate_new_title: '產生新的備用碼',
        generate_new: '產生新的備用碼',
    },
    passkey: {
        title: '通行密鑰',
        added: '新增於：{{date}}',
        last_used: '上次使用：{{date}}',
        never_used: '從未使用',
        unnamed: '未命名的通行密鑰',
        renamed: '通行密鑰已成功重新命名。',
        deleted: '通行密鑰已移除。',
        add_another_title: '新增另一個通行密鑰',
        add_another_description: '使用設備生物識別、安全金鑰（例如 YubiKey）或其他可用方法註冊您的通行密鑰。',
        add_passkey: '新增通行密鑰',
        delete_confirmation_title: '移除您的通行密鑰',
        delete_confirmation_description: '如果您移除此通行密鑰，您將無法使用它進行驗證。',
        rename_passkey: '重新命名通行密鑰',
        rename_description: '為此通行密鑰輸入新名稱。',
        name_this_passkey: '為此裝置通行密鑰命名',
        name_passkey_description: '您已成功驗證此裝置用於兩步驗證。自訂名稱以便在擁有多個密鑰時進行識別。',
        name_input_label: '名稱',
    },
    sessions: {
        page_title: '工作階段',
        page_description: '管理你的活躍工作階段和已授權的第三方應用程式。',
        title: '工作階段',
        current_session: '目前工作階段',
        signed_in_at: '登入於 {{date}}',
        revoke_session: '登出',
        revoke_session_title: '登出工作階段',
        revoke_session_description: '這將登出該工作階段並撤銷所有相關的存取權限。確定要繼續嗎？',
        no_other_sessions: '沒有其他活躍的工作階段。',
        loading: '載入中...',
        third_party_apps_title: '第三方應用程式',
        no_third_party_apps: '沒有已授權的第三方應用程式。',
        third_party_apps_load_failed: '無法載入第三方應用程式。請再試一次。',
        granted_at: '授權於 {{date}}',
        revoke_grant: '移除',
        revoke_grant_title: '移除第三方應用程式存取權限',
        revoke_grant_description: '這將撤銷授予該應用程式的所有存取權限。確定要繼續嗎？',
        revoke_grant_failed: '部分授權撤銷失敗，請重試。',
    },
};
export default Object.freeze(account_center);
